import styled from "styled-components";

import { DATA_E2E_KEY, IStyledAttributes } from "@ryde/shared";
import { blueGreyMui } from "@ryde/theme";

export const LiveMapRefreshIntervalFieldsStyled = styled.span.attrs<IStyledAttributes>(
  {
    [DATA_E2E_KEY]: "live-map-refresh-interval-fields",
  },
)`
  display: inline-flex;
  align-items: center;
  gap: 8px;
`;

export const LiveMapRefreshIntervalInputGroupStyled = styled.span.attrs<IStyledAttributes>(
  {
    [DATA_E2E_KEY]: "live-map-refresh-interval-input-group",
  },
)`
  position: relative;
  display: inline-flex;
  align-items: center;
  gap: 2px;

  .MuiTextField-root {
    position: relative;
  }

  .MuiFormHelperText-root {
    position: absolute;
    top: 100%;
    left: 0;
    margin: 2px 0 0;
    font-size: 10px;
    line-height: 1;
    white-space: nowrap;
  }
`;

export const LiveMapRefreshIntervalSecLabelStyled = styled.span.attrs<IStyledAttributes>(
  {
    [DATA_E2E_KEY]: "live-map-refresh-interval-sec-label",
  },
)`
  font-size: 11px;
  color: ${blueGreyMui._500};
  line-height: 1;
  margin-inline: 2px 0;
`;

export const LiveMapRefreshIntervalControlStyled = styled.div.attrs<IStyledAttributes>(
  {
    [DATA_E2E_KEY]: "live-map-refresh-interval-control",
  },
)`
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 11px;
  color: ${blueGreyMui._500};
  white-space: nowrap;
  user-select: none;

  .MuiInputBase-root {
    width: 43px;
  }

  .MuiInputBase-input {
    padding: 2px 4px;
    text-align: center;
    font-size: 11px;
  }

  .MuiIconButton-root {
    padding: 2px;
  }
`;
